module.exports = __webpack_public_path__ + "img/konfigurasi_konten.edbe479c.svg";